import Block from '../block'
import { LuminousGallery } from 'luminous-lightbox'

export default class Lightbox extends Block {
	static title = 'lightbox'

	init() {
		this.images = this.element.querySelectorAll('.lightbox__trigger')

		this.initGallery()
	}

	initGallery() {
		this.lightbox = new LuminousGallery(
			this.images,
			{ arrowNavigation: true },
			{ showCloseButton: true }
		)
	}
}
